import { useEffect, useState } from 'react'
import { ITable } from './types'
import MUITable from '@mui/material/Table'
import Paper from '@mui/material/Paper'
import TableContainer from '@mui/material/TableContainer'
import {
  Box,
  Pagination,
  PaginationItem,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import colors from '../../constants/colors'

const TableTAG: React.FC<ITable> = props => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [numberOfPages, setNumberOfPages] = useState(1)

  useEffect(() => {
    if (props.rowsPerPage) setRowsPerPage(props.rowsPerPage)

    if (props.rows) setNumberOfPages(Math.ceil(props.rows.length / rowsPerPage))
  }, [rowsPerPage, numberOfPages])

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage - 1)
  }

  const findId = (selectedId: number) => {
    const found = props.selectedRows?.find(id => id === selectedId)
    return !!found
  }

  const resolveTableBody = () => {
    if (!props.pagination) {
      return (
        <TableBody sx={{ overflow: 'hidden', position: 'relative' }}>
          {props.rows?.map(row => (
            <TableRow
              hover
              role='checkbox'
              tabIndex={-1}
              key={row?.code ?? Math.random()}
              onClick={() => {
                props.onRowClick && props.onRowClick(row)
              }}
              selected={findId(row?.id)}
            >
              {props.columns.map(column => {
                const value = row[column?.id]
                return (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    sx={{ borderBottom: 1, py: '18px', maxWidth: '250px' }}
                  >
                    {column.format ? column.format(value, row) : value}
                  </TableCell>
                )
              })}
              {props.cellActionContent && (
                <TableCell key={props.cellActionKey} align={props.cellActionAlign}>
                  {props.cellActionContent(row)}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      )
    }
    return (
      <TableBody>
        {props.rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
          <TableRow
            hover
            role='checkbox'
            tabIndex={-1}
            key={row.code ?? Math.random()}
            onClick={() => {
              props.onRowClick && props.onRowClick(row)
            }}
            selected={findId(row?.id)}
          >
            {props.columns.map(column => {
              const value = row[column.id]
              return (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sx={{ borderBottom: 1, py: '18px' }}
                >
                  {column.format ? column.format(value, row) : value}
                </TableCell>
              )
            })}
            {props.cellActionContent && (
              <TableCell key={props.cellActionKey} align={props.cellActionAlign}>
                {props.cellActionContent(row)}
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    )
  }

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        // height: '100%',
        // overflow: 'auto',
        backgroundColor: colors.WHITE,
        ...props.sx,
      }}
    >
      <TableContainer style={{ maxHeight: '50vh', position: 'relative' }}>
        <MUITable stickyHeader aria-label='sticky table'>
          {props?.colWidths && (
            <colgroup>
              {props?.colWidths.map((colWidth, i) => (
                <col key={`colWidth_${i}`} width={colWidth} />
              ))}
            </colgroup>
          )}

          <TableHead>
            <TableRow>
              {props.columns.map(column => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sx={{
                    borderBottom: 2,
                  }}
                >
                  <Typography variant='labelBold'>{column.label}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {resolveTableBody()}
        </MUITable>
        {props.pagination && (
          <Box
            sx={{
              position: 'sticky',
              bottom: 0,
              height: '6rem',
              width: '100%',
              background: ' linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 64.06%)',
            }}
          />
        )}
      </TableContainer>

      {props.pagination && (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', paddingTop: '44px' }}>
          <Pagination
            id='testtest'
            count={numberOfPages}
            page={page + 1}
            shape='rounded'
            onChange={handleChangePage}
            renderItem={item => (
              <PaginationItem
                components={{
                  next: props => <span {...props}>Next</span>,
                  previous: props => <span {...props}>Previous</span>,
                }}
                {...item}
              />
            )}
          />
        </Box>
      )}
    </Paper>
  )
}

export default TableTAG
